import {useQuery} from '@tanstack/react-query';
import {communicationApi} from '../api';
import {CommunicationMessageDetailModel} from '../model';

export const useCommunicationMessage = (messageId: string) => {
  const getMessageById = useQuery<CommunicationMessageDetailModel, Error>({
    queryKey: ['communication-message', messageId],
    queryFn: () => communicationApi.getMessageById(messageId),
    enabled: !!messageId,
  });

  return {
    getMessageById,
  };
};
